import orderBy from 'lodash/orderBy'
import sum from 'lodash/sum'

export function clips(state) {
    return state.project.clips
}

export function clipsInPlayOrder(state) {
    return orderBy(state.project.clips, 'order', 'asc')
}

export function isLoaded(state) {
    return !!state.project
}

export function isPlaying(state) {
    return !!state.playingClipId
}

export function getClipById(state) {
    return id => state.project.clips.find(c => c.id == id)
}

export function totalOverallTime(state) {
    const durations = state.project.clips.map(getClipDuration)
    return sum(durations)
}

export function absoluteTime(state) {
    const playlist = clipsInPlayOrder(state)
    const currentClipIndex = playlist.findIndex(c => c.id == state.playingClipId)
    const previousClips = playlist.slice(0, currentClipIndex)
    const previousDurations = previousClips.map(getClipDuration)
    return sum(previousDurations) + state.relativeTime
}

function getClipDuration(clip) {
    const startTime = clip.start_time || 0
    const endTime = clip.end_time || clip.video.duration
    return endTime - startTime
}